// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608131523/js/" + chunkId + "." + {"44":"7ba68f50","225":"33a35d23","481":"1e7109ff","486":"784387e4","770":"d703ec7f"}[chunkId] + ".0.3941106146764217.chunk.js";
};